import styled from '@emotion/styled';
import Tooltip, {tooltipClasses} from '@mui/material/Tooltip';
import React from 'react';

export const NoMaxWidthTooltip = styled(({className, backgroundColor, children, ...props}) => (
  <Tooltip {...props} classes={{popper: className}}>
    {children}
  </Tooltip>
))((props) => {
  return {
    [`& .${tooltipClasses.tooltip}`]: {
      maxWidth: 'none',
      backgroundColor: props.backgroundColor
    },
    [`& .${tooltipClasses.tooltip} .${tooltipClasses.arrow}`]: {color: props.backgroundColor}
  };
});
